import React from 'react'
import PropTypes from 'prop-types'

import './index.scss'

const LEVELS = [1, 2, 3, 4, 5, 6]

const Heading = ({level, children}) => {
  const headerLevel = LEVELS.includes(level) ? level : 1
  const Component = `h${headerLevel}`

  return (
    <Component className="default">{children}</Component>
  )
}

Heading.propTypes = {
  level: PropTypes.number,
  children: PropTypes.node,
}

export default Heading
